import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { useAccount } from 'src/hooks'

import { ProductPreviewModal, StoreCampaignPreview } from '..'
import { Item } from '../../types'
// TODO split that
import styles from '../../containers/campaignStore.module.scss'

interface Props {
  item: Item
  onClose: () => void
  onPurchase: (id: string) => void
}

const ItemComponent: React.FC<Props> = props => {
  const { item, onClose, onPurchase } = props

  const account = useAccount()

  /* Items can model both a product (when the "campaign" attribute is null)
     or an actual campaigns (when "campaign" is set). Render the proper component
     accordingly */

  return (
    <div>
      <TransitionGroup>
        <CSSTransition
          classNames={styles.store}
          timeout={{ enter: 500, exit: 300 }}
        >
          <>
            {item.campaign && (
              <StoreCampaignPreview
                item={item}
                onClose={onClose}
                onPurchase={item => onPurchase(item.id)}
                isUserStaff={account.isStaff}
              />
            )}
          </>
        </CSSTransition>
      </TransitionGroup>

      {!item.campaign && (
        <ProductPreviewModal
          product={item}
          onClose={onClose}
          onPurchase={product => onPurchase(product.id)}
        />
      )}
    </div>
  )
}

export default ItemComponent
